import { render, staticRenderFns } from "./testingPointPic.vue?vue&type=template&id=2894c74e&scoped=true&"
import script from "./testingPointPic.vue?vue&type=script&lang=ts&"
export * from "./testingPointPic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894c74e",
  null
  
)

export default component.exports